import React from "react";
import * as S from "./accountNav.style.ts";
import Button from "../../components/Button/Button.tsx";
import { useAtomValue } from "jotai";
import { userAtom } from "../../hook/UserAtom.ts";
import { useNavigate } from "react-router-dom";

interface AccountNavProps {
  setSelectedOption: (val: string) => void;
  selectedOption: string;
}

const AccountNav = ({ setSelectedOption, selectedOption }: AccountNavProps) => {
  const currentUser = useAtomValue(userAtom);
  const navigate = useNavigate();

  return (
    <S.NavWrapper>
      {currentUser?.hasBudget && (
        <S.NavItem
          className={selectedOption === "cash-flow" ? "open" : "close"}
        >
          <Button
            classType="text"
            handleClick={() => {
              setSelectedOption("cash-flow");
              navigate("?nav=cash-flow");
            }}
          >
            Cash Flow
          </Button>
        </S.NavItem>
      )}
      <S.NavItem className={selectedOption === "settings" ? "open" : "close"}>
        <Button
          classType="text"
          handleClick={() => {
            setSelectedOption("settings");
            navigate("?nav=settings");
          }}
        >
          Settings
        </Button>
      </S.NavItem>
    </S.NavWrapper>
  );
};

export default AccountNav;
